import React, { useMemo } from "react";
import { format, isAfter, isSameDay, parseISO } from "date-fns";
import now from "../../util/now";
import { useSession } from "../api/helpers";

const SessionVideoPlaceholder = () => {
  const session = useSession();

  const message = useMemo(() => {
    if (session?.startTime === undefined) {
      return "";
    }
    const start = parseISO(session.startTime);
    const end = parseISO(session.endTime);
    if (session?.status === "NotStarted" && isAfter(end, now)) {
      if (isSameDay(now, parseISO(session.startTime))) {
        return `Session will begin at approximately ${format(
          start,
          "h:mm aaa",
        )}`;
      }
      return `Session will begin on ${format(
        start,
        "EEEE, MMMM do, y",
      )} at ${format(start, "h:mm aaa")}`;
    }
    return "Session has ended";
  }, [session?.endTime, session?.startTime, session?.status]);

  return (
    <div>
      <p>{message}</p>
      <style jsx>{`
        div {
          width: 100%;
          height: 100%;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          vertical-align: center;
        }
        p {
          font-size: 2em;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default SessionVideoPlaceholder;
